import React, { useEffect } from "react";
import MainApp from "./app/MainApp";
import { ReactNotifications } from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import AlertsHandler from "./features/Alerts";
import useDesktopSize from "./utils/hooks/useDesktopSize";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { pl } from "date-fns/locale";
import "./style/buttons.scss";
import ReactPixel from "react-facebook-pixel";
// import { initializeGTM } from "./app/ga4/gtm";
// import { initGA } from "./app/ga4/ga";

const App: React.FC = () => {
  const isDesktop = useDesktopSize();

  useEffect(() => {
    // initGA(["G-42SVFHM9GG", "AW-10936866356"]); wyłączam na prośbe Julinka
    ReactPixel.init("619131988827550");
    // initializeGTM(); //inicjalizacja GTM tag
  }, []);

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={pl}>
      <ReactNotifications isMobile={!isDesktop} />
      <AlertsHandler />
      <MainApp />
    </MuiPickersUtilsProvider>
  );
};

export default App;
